/* global angular */

var ngModule = angular.module('trends');

ngModule.service('Redirect', ['$rootScope', '$state', '$window', '$timeout', 'Api',
    function ($rootScope, $state, $window, $timeout, Api) {

        this.initialize = function(opts) {
            opts = opts || {};
            this.hasTrendsAccess = opts.hasTrendsAccess || false;
            this.isLoggedIn = opts.isLoggedIn || false;
            isInitialized = true;
        };

        var that = this;
        var isInitialized = false;
        var timeIntervalInSec = 300;

        var updateLoggedIn = function() {
            Api.loggedIn.get().then(function (obj) {
                if (obj && obj.objects && obj.objects[0]) {
                    var is_logged_in = obj.objects[0].is_logged_in;
                    if (is_logged_in !== null && is_logged_in !== undefined) {
                        that.isLoggedIn = is_logged_in;
                    }
                }
            });
            $timeout(updateLoggedIn, 1000 * timeIntervalInSec);
        };

        updateLoggedIn();

        $rootScope.$on('$stateChangeStart', function(event, toState) {
            if (!isInitialized) {
                return;
            }
            if (!that.isLoggedIn && toState.name !== 'homepage' && toState.name !== 'logged-off') {
                event.preventDefault();
                $window.location.href = '/?logon&start=redirect&args=' +
                    encodeURIComponent($window.location.pathname + $window.location.hash);
            }
            else if (toState.name === 'logged-off' || !that.isLoggedIn || !that.hasTrendsAccess) {
                event.preventDefault();
                $window.location.href = 'http://www.mintel.com/mintel-trends/request-more-information';
            }
            else {
                return;
            }
        });
    }]);
